import { Fragment, useState } from "react";
import classNames from "classnames";

import { translate } from "@ascendnow/shared";

import AscButton from "../../AscButton/AscButton";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import { CloseFilledIcon } from "../../AscIcons";
import styles from "./AscProjectCard.module.scss";
import { DeleteProjectModal } from "./DeleteModal";

export interface AscProjectCardProps {
  className?: string;
  title: string;
  coverImageUrl?: string;
  buttonTitle?: string;
  onClick?: () => void;
  deleteHandler?: (cb: () => void) => void;
}

export default function AscProjectCard({
  className,
  title,
  coverImageUrl,
  onClick,
  buttonTitle = translate("edit"),
  deleteHandler,
}: AscProjectCardProps) {
  const [deleteModal, setDeleteModal] = useState(false);

  const handleDelete = () => {
    deleteHandler?.(() => setDeleteModal(false));
  };

  return (
    <Fragment>
      <div className={styles.wrapper}>
        {deleteHandler && (
          <span className={styles.delete} onClick={() => setDeleteModal(true)}>
            <CloseFilledIcon />
          </span>
        )}
        <AscGenericCard
          title={title}
          coverImageUrl={coverImageUrl}
          titleClassName={styles.title}
          data-testid="asc-project-card"
          className={classNames(styles.ground, className)}
        >
          <AscButton fullWidth narrowPadding onClick={onClick}>
            {buttonTitle}
          </AscButton>
        </AscGenericCard>
      </div>
      {deleteHandler && (
        <DeleteProjectModal
          {...{
            visible: deleteModal,
            setVisible: setDeleteModal,
            deleteProject: handleDelete,
          }}
        />
      )}
    </Fragment>
  );
}
